import PersonalCapsuleEvaluationList
    from "../../modules/PersonalCapsuleEvaluation/PersonalCapsuleEvaluationList/personalCapsuleEvaluationList";

export default function PersonalCapsuleEvaluationScreen() {
    
    return (
        <>
            <PersonalCapsuleEvaluationList/>
        </>
    );
}